import { render } from "./SponsorDetails.vue?vue&type=template&id=1402303d&scoped=true"
import script from "./SponsorDetails.vue?vue&type=script&lang=js"
export * from "./SponsorDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1402303d"

export default script